<div class="form-loading" *ngIf="loading">
  <div class="spinner"></div>
</div>

<div class="basic-form" *ngIf="!loading">
  <form action="#" [formGroup]="productForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <!-- Categoría -->
      <div class="mb-3 col-md-6 col-lg-4">
        <label class="form-label">Categoría</label>
        <div class="category-row">
          <div class="flex-1">
            <select2
              formControlName="categories"
              [data]="categoriesOptions"
              [value]="selectedCategory"
              (update)="onCategoryChange($event)"
            >
            </select2>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm add-cat-btn" (click)="onNewCategory()" title="Nueva categoría">
            +
          </button>
        </div>
        <div
          *ngIf="
            productForm?.get('categories')?.touched &&
            productForm?.get('categories')?.invalid
          "
          class="text-danger"
        >
          Seleccione una categoría.
        </div>
      </div>

      <!-- SKU -->
      <div class="mb-3 col-md-6 col-lg-4">
        <label class="form-label">SKU</label>
        <input
          type="text"
          class="form-control"
          formControlName="sku"
          placeholder="Sku"
        />
        <div
          *ngIf="
            productForm?.get('sku')?.touched && productForm?.get('sku')?.invalid
          "
          class="text-danger"
        >
          Ingrese un SKU.
        </div>

        <div *ngIf="skuExists" class="text-danger">
          Este SKU ya existe. Por favor, ingrese otro.
        </div>
      </div>

      <!-- Nombre -->
      <div class="mb-3 col-md-6 col-lg-4">
        <label class="form-label">Nombre</label>
        <input
          type="text"
          class="form-control"
          formControlName="nombre"
          placeholder="Nombre"
        />
        <div
          *ngIf="
            productForm?.get('nombre')?.touched &&
            productForm?.get('nombre')?.invalid
          "
          class="text-danger"
        >
          Ingrese un nombre.
        </div>
        <div *ngIf="nombreExists" class="text-danger">
          Este nombre ya está registrado. Intente con otro.
        </div>
      </div>
    </div>

    <!-- Descripción -->
    <div class="row">
      <div class="mb-3 col-md-12">
        <label class="form-label">Descripción</label>
        <textarea class="form-control" formControlName="descripcion"></textarea>
        <div
          *ngIf="
            productForm?.get('descripcion')?.touched &&
            productForm?.get('descripcion')?.invalid
          "
          class="text-danger"
        >
          Agregue una descripción.
        </div>
      </div>
    </div>

    <div class="row two-cols">
      <!-- Costo -->
      <div class="mb-3 col">
        <label class="form-label">$ Costo</label>
        <input type="number" class="form-control" formControlName="costo" />
        <div
          *ngIf="
            productForm?.get('costo')?.touched &&
            productForm?.get('costo')?.invalid
          "
          class="text-danger"
        >
          Agregue el costo del producto.
        </div>
      </div>

      <!-- Venta -->
      <div class="mb-3 col">
        <label class="form-label">$ Venta</label>
        <input type="number" class="form-control" formControlName="venta" />
        <div
          *ngIf="
            productForm?.get('venta')?.touched &&
            productForm?.get('venta')?.invalid
          "
          class="text-danger"
        >
          Agregue el valor de venta.
        </div>
      </div>
    </div>

    <!-- Porciones -->
    <div class="row">
      <div class="mb-3 col-md-6">
        <label class="form-label">Porciones</label>
        <div class="category-row">
          <div class="flex-1">
            <select2
              formControlName="unitTypes"
              [data]="unitTypesOptions"
              [value]="selectedUnitType"
              (update)="onUnitTypeChange($event)"
            >
            </select2>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm add-cat-btn" (click)="onNewPortion()" title="Nueva porción">
            +
          </button>
        </div>
        <div
          *ngIf="
            productForm?.get('unitTypes')?.touched &&
            productForm?.get('unitTypes')?.invalid
          "
          class="text-danger"
        >
          Seleccione un tipo de medida.
        </div>
      </div>
    </div>

    <!-- Opciones de Producto -->
    <div class="row">
      <div class="mb-3 col-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label mb-0">Opciones del Producto</label>
          <button type="button" class="btn btn-outline-primary btn-sm" (click)="addOption()" title="Agregar opción">
            <mat-icon>add</mat-icon> Agregar Opción
          </button>
        </div>
        
        <div *ngIf="options.length === 0" class="text-muted text-center py-3 border rounded">
          No hay opciones configuradas
        </div>
        
        <div class="options-list" *ngIf="options.length > 0">
          <div *ngFor="let opt of options; let i = index" class="option-row border rounded p-2 mb-2">
            <div class="row align-items-center">
              <div class="col-md-5">
                <ui-input
                  label="Nombre"
                  [(value)]="opt.name"
                  placeholder="Nombre de la opción"
                />
              </div>
              <div class="col-md-4">
                <ui-input
                  label="Delta Precio"
                  type="number"
                  [(value)]="opt.priceDelta"
                  placeholder="0"
                  [step]="0.01"
                  [min]="0"
                />
              </div>
              <div class="col-md-3">
                <div class="d-flex gap-2 align-items-end h-100">
                  <ui-button
                    variant="ghost"
                    size="sm"
                    (click)="removeOption(i)"
                    class="text-danger"
                  >
                    <mat-icon>delete</mat-icon>
                  </ui-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Historial de precios (solo edición) -->
    <div class="row" *ngIf="productInfo?.uuid">
      <div class="col-12 mb-3">
        <hr />
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label mb-0 fw-semibold">Historial de precios</label>
        </div>

        <!-- Formulario nuevo precio histórico -->
        <div class="price-hist-form border rounded p-3 mb-3 bg-light">
          <div class="row g-2 align-items-end">
            <div class="col-md-3 col-6">
              <label class="form-label form-label-sm">$ Venta</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="histSellPrice" [ngModelOptions]="{standalone: true}" placeholder="0" min="0" />
            </div>
            <div class="col-md-3 col-6">
              <label class="form-label form-label-sm">$ Costo</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="histCostPrice" [ngModelOptions]="{standalone: true}" placeholder="0" min="0" />
            </div>
            <div class="col-md-3 col-6">
              <label class="form-label form-label-sm">Fecha</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="histDate" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-md-3 col-6">
              <button type="button" class="btn btn-primary btn-sm w-100"
                [disabled]="histSaving || histSellPrice === null || histCostPrice === null || !histDate"
                (click)="savePriceHistory()">
                <mat-icon style="font-size:16px;width:16px;height:16px;vertical-align:middle">add</mat-icon>
                {{ histSaving ? 'Guardando...' : 'Registrar' }}
              </button>
            </div>
          </div>
        </div>

        <!-- Lista del historial -->
        <div *ngIf="histLoading" class="text-muted small text-center py-2">Cargando historial...</div>
        <div *ngIf="!histLoading && priceHistory.length === 0" class="text-muted small text-center py-2 border rounded">Sin registros de precio</div>
        <div *ngIf="!histLoading && priceHistory.length > 0" class="price-hist-list">
          <div class="price-hist-header price-hist-row">
            <span>Fecha</span>
            <span>Venta</span>
            <span>Costo</span>
            <span>Por</span>
          </div>
          <div *ngFor="let h of priceHistory" class="price-hist-row">
            <span class="text-muted small">{{ h.changedAt | date:'dd/MM/yyyy HH:mm' }}</span>
            <span class="fw-semibold">${{ h.sellPrice | number:'1.0-0' }}</span>
            <span class="text-muted">${{ h.costPrice | number:'1.0-0' }}</span>
            <span class="text-muted small">{{ h.changedByName || '—' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Botones de acción -->
    <div class="row">
      <div class="mb-3 col-md-12 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light" (click)="onCancel()">
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!checkIfFormIsValid()"
        >
          Agregar
        </button>
      </div>
    </div>
  </form>
</div>

<ng-template #template let-data>
  {{ data?.name | titlecase }}
</ng-template>
